<i18n>
{
    "en": {},
    "ru": {
        "title": "Создатели ароматов",
        "title_with_letter": "Создатели ароматов – {word}",
        "introtext": "<p>Главные и второстепенные лица парфюмерной индустрии: узнайте больше о людях, создающих ароматы. Фото, информация, биографии и портфолио парфюмеров и арт-директоров.</p>",
        "description": "<p>Профессия парфюмера часто окружена мифами и домыслами: кажется, что люди, которые придумывают формулы ароматов, живут в параллельном мире, где нет места рутинной работе, а отвлечь от высокого может только некачественное масло дамасской розы. Это не так: создатель духов — интересное, но менее романтичное, чем можно подумать, занятие. В нем, как и в других сферах, есть профессионалы и любители, люди, получившие формальное образование (ISIPCA, Грасский институт парфюмерии, школа Givaudan и проч.) и те, кто обучались самостоятельно, есть звезды — авторы знакомых всем хитов и художники, работающие со сложными «нишевыми» профилями. При этом говорить о «носах» парфюмерии, как их называют, начали всего пару десятилетий назад; большую роль в этом сыграли деятельность Фредерика Маля, появление профессиональных выставок (Esxence, Pitti Fragranze) и развитие тематических СМИ и блогов. Одна из других важных тенденций — внимание не только к парфюмеру, но и к роли арт-директора: человека, который придумывает концепцию аромата и следит за ее реализацией.</p><h2>Парфюмеры: каталог Aromo</h2><p>В энциклопедии Aromo собрана вся информация о парфюмерах, арт-директорах, владельцах брендов и дизайнерах флаконов. Мы уделяем внимание не только их творческой биографии, но и художественному почерку: рассказываем о характерных отличиях стиля, личных интересах и жизни за пределами лаборатории. В этом разделе — и известные парфюмеры, ароматы которых можно найти в любом универмаге, и хозяева артизанальных марок, знакомых узкому кругу поклонников, и креативные директора, повлиявшие на развитие индустрии: все, кто делает современную парфюмерию такой, какая она есть. Тексты про парфюмеров в каталоге сопровождают работы из их портфолио, отсортированные по популярности — от самых узнаваемых до менее известных.</p><h3>Известные парфюмеры и их ароматы</h3><p>Вплоть до 2000-х создатели ароматов, за редким исключением, оставались в тени производственных процессов, уступая публичное пространство имени бренда и «лицу» композиции. Человеком, изменившим правила игры, стал французский предприниматель Фредерик Маль: внук президента Christian Dior Parfums, коллекционер искусства и племянник режиссера Луи Маля основал «издательство» (Editions de Parfums Frédéric Malle), в работах которого стал выносить фамилии парфюмеров прямо на поверхность флакона. Это был первый шаг к глобальной тенденции на прозрачность производственных процессов; сейчас Маля называют живым классиком, а имена «носов», с которыми он работает, знакомы большинству людей, интересующихся духами. Вот несколько примеров ароматов, созданных известными парфюмерами:</p><ul><li>Gucci Bloom, Gucci (автор — Альберто Морийяс, художественное руководство — Алессандро Микеле);</li><li>Fleur Narcotique, Ex Nihilo (совместная работа парфюмера Квентина Биша и владельцев марки Оливье Ройера и Бенуа Вердье);</li><li>Angel, Mugler (хит парфюмера Оливье Креспа по заказу Тьерри Мюглера);</li><li>Bal d’Afrique, Byredo (дуэт Жерома Эпинетта и креативного директора бренда Бена Горхэма);</li><li>Tobacco Vanille, Tom Ford (формула Оливье Гийотена, идея Тома Форда).</li></ul><p>При этом далеко не все современные марки спешат раскрывать имена авторов своих ароматов. Как правило, этой стратегии придерживаются бренды, опасающиеся заимствований, перепродажи формул и стремящиеся сохранить фокус внимания клиента на себе.</p><p>Противоположность таким проектам — бренды, образ которых связан с тем или иным парфюмером, причем это могут быть как крупные люксовые дома (Guerlain и Тьерри Вассер, Chanel и Оливье Польж, Dior и Франсуа Демаши и т.д.), так и артизанальные марки вроде Andy Tauer, Aftelier (Мэнди Афтель), Francesca Bianchi и проч. Популярность феминизма отчасти поддерживает эту тенденцию: женских голосов в индустрии становится все больше, и многие из них звучат далеко за пределами лабораторий: имена Калис Беккер, Сесиль Зарокян, Писсары Умавиджани, Патрисии де Николаи, Натали Лорсон, Натали Фейстауэр, Оливии Джакобетти хорошо известны и профессионалам, и любителям.<p><h3>Знаменитые парфюмеры: от чего зависит успех аромата?</h3><p>Многие связывают успех той или иной композиции исключительно с талантом парфюмера, но это суждение не совсем корректно. Парфюмерия — продукт совместной работы нескольких людей, поэтому результат зависит не только от автора формулы, но и от пожеланий владельца бренда, арт-директора и отдела маркетинга, в ряде случаев — от мнения фокус-группы и других специалистов. Коммерчески успешный аромат — чаще всего тот, который отвечает вкусу и запросам большинства клиентов; такие запуски редко приносят в парфюмерию что-то новое, но могут стимулировать интерес покупателей к различным жанрам. Один из ярких примеров —  La Vie Est Belle Оливье Польжа, Доминика Ропьона и Анн Флипо для Lancôme, с которого в 2012 году начался тренд на гурманские композиции. В работе над ароматом приняли участие сразу три «звездных» парфюмера, но сказать, что именно сделало его таким успешным — удачная формула, частая реклама бренда на ТВ, в прессе и сети, верное позиционирование или поддержка знаменитостей — непросто. С другой стороны, ранее у тех же авторов выходили менее популярные работы, что доказывает важность роли не только парфюмера, но и остальных членов команды.</p>",
        "search_placeholder": "Введите имя персоны...",
        "perfume_one": "аромат",
        "perfume_few": "аромата",
        "perfume_many": "ароматов",
        "person_one": "персона",
        "person_few": "персоны",
        "person_many": "персон",
        "popular": "По популярности",
        "rating": "По рейтингу",
        "alphabet": "По алфавиту",
        "best_articles": "Лучшие статьи",
        "chained_pages": "Интересные подборки",
        "by_filter": "(по фильтру)",
        "meta": {
            "title": "Парфюмеры и ко: кто стоит за созданием аромата",
            "description": "Известные парфюмеры, независимые художники, авторы мировых хитов и экспериментальных композиций: разбираемся, из чего состоит профессия парфюмера и вспоминаем имена главных героев индустрии."
        }
    }
}
</i18n>

<template>
    <div class="noses-page">

        <block-price-panel />

        <div class="noses-page__block">
            <PageBlock contentVisible>
                <Breadcrumb
                    :items="breadcrumbs"
                    :show-prev-button="showPrevBtn"
                    :prev-path-url="prevRoute"/>
                <SectionCard :loaded="loaded">
                    <template #main>
                        <div class="noses-page__content">
                            <PageBlock
                                :title="getTitle"
                                :caption="titleCaption"
                                :caption-count="totalItems | numberFormat"
                                :small-header="!isDeviceDesktop"
                                class="noses-page__title-name"
                                :heading-tag="'h1'">

                                <ShowMore v-if="!isDeviceDesktop && catalogPage === 1"
                                    :max-rows="5"
                                    :collapse-from="'.noses-page__content'"
                                    :collapse-to="'.noses-page__content'"
                                    class="page-block__description-wrapper">
                                    <!-- eslint-disable-next-line -->
                                    <div class="page-block__description html-content" v-html="mobileText"></div>
                                </ShowMore>
                                <!-- eslint-disable-next-line -->
                                <div v-html="$t('introtext')" class="page-block__description-wrapper html-content"
                                    v-else></div>

                            </PageBlock>
                        </div>
                    </template>
                </SectionCard>

                <CatalogList
                    class="noses-page__list"
                    :grid="isDeviceDesktop"
                    :sortInSearchField="isDeviceDesktop"
                    :grid-columns="5"
                    :active-letter="letter"
                    :letters="lettersList"
                    letters-switcher
                    :lettersUrl="catalogHref"
                    letter-route-name="NosesLetterList"
                    @letter-selected="onSelectLetter"
                    id="noses_list"
                    :placeholder="$t('search_placeholder')"
                    :search-loading="queryPending"
                    @search="searchQuery = $event"
                    :query="searchQuery"
                    @change-sort-type="onChangeSortType"
                    @change-sort-order="onChangeSortOrder"
                    @reset-all="resetAll"
                    :items="catalogItems"
                    :with-pagination="parseInt(catalogLastPage) > 1"
                    :sort-options="sortOptions"
                    v-model="catalogPage"
                    :page-count="catalogLastPage"
                    :sort-order="sortOrder"
                    :sort-type="sortType"
                    :sticky-letters="true"
                    :sticky-filter="false"
                    showAllUrl
                    withFilter
                    filterInSearchField
                    @show-filter="onShowFilter"
                    :filters-count="filtersCount"
                    filter-in-search-field>
                    <template #item="{ item, language }" >

                        <BaseUnit
                            :isColumn="isDeviceDesktop"
                            entity-type="nose"
                            :size="isDeviceDesktop ? 'large' : null"
                            :name="language === 'ru' ? item.name : get(item, 'alternativeName', item.name)"
                            :url="get(item, 'htmlUrl')"
                            :picture="get(item, 'picture.url')"
                            :counter="getPerfumerItemsCaption(item)"
                            :caption="get(item, 'position')"
                            class="base-unit_nose" />

                    </template>
                </CatalogList>
            </PageBlock>

            <client-only>
                <RecentItems
                    class="noses-page__recent"
                    :code="'perfumer'"
                    :per-view="12" />
            </client-only>

            <PageBlock v-if="showRelatedArticles" :title="$t('best_articles')">
                <div class="perfume__page-block">
                    <ArticleRowItem
                        :key="index + article"
                        v-for="(article, index) in relatedArticles"
                        :data="article"/>
                </div>
            </PageBlock>
            <PageBlock v-if="showRelatedPages" :title="$t('chained_pages')">
                <div class="perfume__page-block">
                    <LinkedPagesList :items="relatedPages"/>
                </div>
            </PageBlock>

            <!-- eslint-disable-next-line -->
            <div v-html="$t('description')"
                v-if="isDeviceDesktop && catalogPage === 1"
                class="html-content html-content_bottom">
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import get from 'lodash/get';
import assignIn from 'lodash/assignIn';
import filter from 'lodash/filter';
import url from '@/filters/url';

import Breadcrumb from '@/components/layout/nav/Breadcrumb';
import PageBlock from '@/components/layout/AppPageBlock';
import SectionCard from '@/components/layout/AppSectionCard';
import CatalogList from '@/components/catalog/CatalogList';
import ArticleRowItem from '@/components/layout/blocks/ArticlesList/ArticleRowItem';
import LinkedPagesList from '@/components/layout/blocks/LinkedPagesList';
import BlockPricePanel from '@/components/catalog/BlockPricePanel';
import RecentItems from '@/components/catalog/RecentItems';

import { getCatalogQuery, getApiQueryParams, CatalogListMixin } from '@/mixins/catalog/catalogList.mixin';
import Perfumer from '@/models/catalog/Perfumer';

export default {
    name: 'Noses',
    components: {
        LinkedPagesList,
        ArticleRowItem,
        CatalogList,
        SectionCard,
        PageBlock,
        Breadcrumb,
        BlockPricePanel,
        RecentItems
    },
    mixins: [CatalogListMixin],
    asyncData({ app, query, params, route, error }) {
        const letter = (params && params.letter) ? params.letter.toUpperCase() : undefined;
        const baseUrl = app.i18n.__baseUrl
        const catalogHref = app.router.resolve({
            name: 'Noses'
        }).href

        const noses = new Perfumer;

        // массив фильтров из query
        const catalogParams = getCatalogQuery(query, true)

        // берём параметры для запроса из query или дефолт
        const perPage = catalogParams.perPage || 100
        const searchQuery = catalogParams.searchQuery || ''
        const catalogPage = url.getPageNumber(route.path);
        const sortType = catalogParams.sortType || 'popularity'
        const sortOrder = catalogParams.sortOrder || 'desc'
        const filters = catalogParams.filters || {}

        const queryParams = {
            ...getApiQueryParams(query),
            page: catalogPage
        };

        // Формируем параметры
        const perfumersParams = assignIn({}, queryParams, filters);
        perfumersParams.letter = letter;

        const requests = [
            noses.params(perfumersParams).get(),
            noses.perfumersAlphabet().get(),
            noses.relatedArticles().get(),
            noses.relatedPages().get(),
            noses.filters()
        ];

        return Promise.all(requests).then(results => {
            const breadcrumbs = [
                {
                    path: baseUrl,
                    name: app.i18n.t('breadcrumbs.perfumes'),
                },
                {
                    path: baseUrl + catalogHref,
                    name: app.i18n.t('breadcrumbs.noses'),
                }
            ];
            const lettersList = results[1];


            if (letter) {
                const letterFromList = filter(lettersList, (item) => {
                    return (item.name === letter);
                })[0];

                if (!letterFromList) {
                    error({statusCode: 404});
                }
                breadcrumbs.push({
                    path: baseUrl + catalogHref + letter,
                    name: letter.toUpperCase(),
                })
            }

            // const catalogPage = nosesRequestParams.page;
            // const searchQuery = getApiQueryParams(query).name;
            // const sortType = getApiQueryParams(query).sort ? getApiQueryParams(query).sort : 'popularity';
            // const sortOrder = getApiQueryParams(query).order || 'desc';

            const perfumersData = get(results, '[0][0]', {});
            const totalItems = get(results, '[0][0].total', 0);
            const catalogItems = get(results, '[0][0].items', []);
            const catalogLastPage = get(results, '[0][0].lastPage', 1);
            const relatedArticles = results[2];
            const relatedPages = results[3];
            const perfumersPositions = get(results, '[4].data.positions');

            const perfumersFilter = get(filters, 'positions')

            if (process.server) {
                app.store.dispatch('rest/headers/filterLastModified', {
                    url: [`/perfumers`]
                });
            }

            return {
                breadcrumbs,
                perfumersData,
                lettersList,
                relatedArticles,
                relatedPages,
                catalogHref,
                totalItems,
                catalogPage,
                catalogLastPage,
                catalogItems,
                searchQuery,
                sortType,
                sortOrder,
                letter,
                nextPage: get(results, '[0][0].nextPage', null),
                prevPage: get(results, '[0][0].prevPage', null),
                perfumersPositions,
                perPage,
                perfumersFilter
            }
        }).catch((e) => {
            error({statusCode: e.response.status, message: e.response.data});
        });
    },
    data() {
        return {
            catalogQueryObject: new Perfumer,
            searchQuery: null,
            loaded: false,
            queryPending: false,
            catalogItems: [],
            relatedArticles: [],
            relatedPages: [],
            breadcrumbs: [],
            catalogPage: 1,
            catalogLastPage: 1,
            totalItems: 0,
            sortType: 'popularity',
            sortOrder: 'asc',
            sortOptions: {
                popularity: {
                    name: this.$t('popular')
                },
                name: {
                    name: this.$t('alphabet')
                },
            },
            lettersList: [],
            perfumersData: {},
            catalogHref: null,
            letter: null,
            prevRoute: null,
            perfumersPositions: [],
            perfumersFilter: null
        }
    },
    globalBus: {
        'perfumers-filter-save'({ positions }) {
            this.perfumersFilter = positions
        }
    },
    computed: {
        ...mapGetters(['isDeviceDesktop']),
        getTitle() {
            return this.letter ? this.$t('title_with_letter', { word: this.letter }) : this.$t('title')
        },
        countNosesDeclension() {
            return this.$options.filters.numberDeclension(this.totalItems, this.licenseholdersDeclension, false);
        },
        licenseholdersDeclension() {
            return [
                this.$t('licenseholders_one'),
                this.$t('licenseholders_few'),
                this.$t('licenseholders_many'),
            ];
        },
        showRelatedPages() {
            return this.relatedPages && this.relatedPages.length && !this.isDeviceDesktop
        },
        showRelatedArticles() {
            return this.relatedArticles && this.relatedArticles.length && !this.isDeviceDesktop
        },
        showPrevBtn() {
            return this.prevRoute !== null
        },
        mobileText(){
            return this.$t('introtext') + this.$t('description')
        },
        metaDefault() {
            return {
                title: this.$t('meta.title'),
                description: this.$t('meta.description')
            };
        },
        titleCaption(){
            const filterText = this.letter || this.searchQuery || this.perfumersFilter ? ' ' + this.$t('by_filter') : ''
            const output = this.totalItems ? this.personsDeclension(this.totalItems) : ''

            return output + filterText
        },
        filters() {
            if (!this.perfumersFilter) {
                return {};
            };
            
            return {
                positions: this.perfumersFilter
            }
        },
        filtersCount() {
            const positions = this.filters.positions

            if (positions && positions.length) {
                const positionsArray = positions.split(',')
                return positionsArray.length
            }

            return 0
        },
    },
    watch: {
        itemsTotal(value) {
            this.totalItems = value
        },
        perfumersFilter(value) {
            this.queryPending = true;
            this.catalogPage = 1;

            this.setCatalogQuery(
                this.catalogQueryObject,
                this.searchQuery || null,
                this.catalogPage
            ).then((response) => this.requestDataAdapter(response))
        }
    },
    mounted() {
        this.loaded = true;
    },
    methods: {
        getPerfumerItemsCaption(perfumer) {
            const itemsCount = get(perfumer, 'perfumes.total', null);
            return this.perfumesDeclension(itemsCount, true) || null
        },
        personsDeclension(count) {
            if(count) {
                const declensionArray = [
                    this.$t('person_one'),
                    this.$t('person_few'),
                    this.$t('person_many')
                ];
                return this.$options.filters.numberDeclension(count, declensionArray, false)
            }
        },
        perfumesDeclension(count, showNumbers = false) {
            if(count) {
                const declensionArray = [
                    this.$t('perfume_one'),
                    this.$t('perfume_few'),
                    this.$t('perfume_many')
                ];
                return this.$options.filters.numberDeclension(count, declensionArray, showNumbers)
            }
        },
        get,
        onShowFilter() {
            this.showPopup('perfumers-filter', {
                positions: this.perfumersPositions,
                filter: this.perfumersFilter,
                letter: this.letter
            })
        },
        resetAll() {
            this.perfumersFilter = null;
            this.searchQuery = null;
        }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if(from.name === 'users.favorites') {
                vm.prevRoute = from.path
            } else {
                vm.prevRoute = null
            }
        })
    }
};
</script>

<style lang="less">
.noses-page {

    &__recent{
        @{desktop} & {
            .page-block_recent{
                margin-top: rem(40);
                margin-bottom: rem(40);
            }
        }
    }

    &__title-name {
        --desktop-header-padding-top: rem(24);
        margin-bottom: 0;

        @{desktop} & {
            margin-bottom: rem(26);
        }
    }

    &__list {

        @{desktop} & {
            --grid-item-height: rem(244);

            .search-field__field{
                max-width: 78%;
            }
        }
    }

    .base-unit__caption{
        @{desktop} &{
            white-space: normal;
        }
    }

    @{mobile} & {
        .page-block__description-wrapper.show-more{
            padding-top: 0;
        }
    }
}
</style>
